import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import React from 'react'

const CellWithTooltip = ({ value }: { value: string }) => {
    return value && value !== 'null' ? (
        <TooltipEllipsis text={value ?? ''}>
            <Typography
                style={{
                    fontSize: pxToRem(14),
                    fontFamily: 'Roboto',
                }}
                noWrap
            >
                {value}
            </Typography>
        </TooltipEllipsis>
    ) : (
        <></>
    )
}

export default CellWithTooltip
